module.exports = __webpack_public_path__ + "img/picto-tel.a488df35.svg";